import { useDeviceQueryApi } from "./useDeviceQueryApi";
export function useApiVersion() {
  var queryApi = useDeviceQueryApi();
  return queryApi.useApiVersionQuery();
}